module.exports = __webpack_public_path__ + "img/good-img.e30d9a4e.png";